import Cookies from 'js-cookie';
import { MyStore } from 'kts-platform-frame/redux';
import Timer, { TimerEvent } from 'grey-timer';

/** 验证用户数据 */
export default class VerificationlogIn {

    /** 当前实例 */
    private static _instance: VerificationlogIn;

    /** 获取当前实例 */
    public static get instance(): VerificationlogIn {
        if (!VerificationlogIn._instance) {
            VerificationlogIn._instance = new VerificationlogIn();
        }
        return VerificationlogIn._instance;
    }

    /** 验证计时器 */
    private timer = new Timer(1000, 0);

    /** 构造函数 */
    constructor() {
        if (VerificationlogIn._instance) {
            throw ('对象为单利');
        } else {
            this.timer.on(TimerEvent.TYPE, this.isLogIn);
        }
    }

    /** 开启监控 */
    public start() {
        this.timer.start();
    }

    /** 关闭监控 */
    public stop() {
        this.timer.stop();
    }

    /** 数据验证 */
    public isLogIn() {
        let cookies = Cookies.get('cToken');
        const cToken = MyStore.instance.getState().user.cToken;
        if (window['$$_self'] !== 'iframe') {
            cookies = MyStore.instance.getState().user.cToken;
        }
        // cookies 没有
        if (!cookies || cookies === 'null') {
            console.log(cookies, window.location.pathname, window['$$_self'], '===================');
            if (window.location.pathname.indexOf('/workbench') >= 0) {
                if (window['$$_self'] !== 'iframe') {
                    console.log('tiao========');
                    window.location.href = '/login';
                }
            }
            return true;
        }

        // 内测没有
        if (!cToken) {
            if (window.location.pathname.indexOf('/login') < 0) {
                window.location.href = '/login';
            }

            if (cookies && window.localStorage.getItem('$$/user') && JSON.parse(window.localStorage.getItem('$$/user')).cToken) {
                window.location.href = '/workbench/m/kingxunlian.workbench';
            }

            return true;
        }

        // 内测和cookies不一致
        if (cToken !== cookies) {
            if (window.location.pathname.indexOf('/workbench') >= 0) {
                window.location.href = '/login';
            }
            return true;
        }

        // 停留在登录页面
        if (window.location.pathname === '/login') {
            window.location.href = '/workbench/m/kingxunlian.workbench';
            return false;
        }

        return true;
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/Verification/index.ts